import React, { useEffect, useState, useContext } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useTransition, useSpring, useChain, config } from 'react-spring'
import findIndex from 'lodash/findIndex';
import BuilderContext from '../builder/hooks/context';

import Markup from '../markup';

const sidebarElements = [
  { url: '/design', text: 'Design', icon: 'design' },
  { url: '/logos', text: 'Logos', icon: 'logos' },
  { url: '/name', text: 'Specs', icon: 'name' },
];

const SidebarItem = ({ active, text, icon, themeColor, onl, onClick = null }) => {
  return (
    <Markup.Sidebar.Item icon={icon} active={active} onClick={onClick} themeColor={themeColor}>
      <Markup.Sidebar.ItemImage icon={icon} active={active} themeColor={themeColor}/>
      <Markup.Sidebar.ItemText active={active} themeColor={themeColor} only={onl}>{text}</Markup.Sidebar.ItemText>
    </Markup.Sidebar.Item>
  );
};

function Sidebar({ onlyState = false, onItemClick = null }) {
  const history = useHistory();
  const match = useRouteMatch();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(0);
  const { builder } = useContext(BuilderContext);

  const setActive = (url) => {
    history.push(url);
    if(onItemClick) onItemClick()
  };

  useEffect(() => {
    const index = findIndex(sidebarElements, el => el.url === match.url);
    if (index !== -1) {
      setCurrentIndex(index);
    }
  }, [match]);

  if (onlyState) {
    const el = sidebarElements[currentIndex];
    return <Markup.Sidebar.StateContainer>
      <SidebarItem active text={el.text} icon={el.icon} themeColor={builder.membersData.colorTheme} onl={onlyState} />
    </Markup.Sidebar.StateContainer>
  }

  return (
    <Markup.Sidebar.Container>
      {sidebarElements
        .map((el, itemIndex) => <SidebarItem key={el.url} onClick={() => !builder?.animationState && setActive(el.url)} active={itemIndex === currentIndex} text={el.text} onl={false} icon={el.icon} themeColor={builder.membersData.colorTheme}/>)
      }
      <Markup.Sidebar.ActiveLabel prevIndex={prevIndex} index={currentIndex} />
    </Markup.Sidebar.Container>
  );
};

export default React.memo(Sidebar);
